gameData = {};
game = (function () {
  var _gameName = 'Jacks Beanstalk Bonanza';
  var _gameNameShort = 'JBB';
  var _gameVersionMajor = '1';
  var _gameVersionMinor = '0';
  var _gameVersionBugFix = '18';
  let _gameReleaseDate = '17/04/2026';
  let _splashScreenPanelSwapping = false;
  let _currentSplashScreenPanelIndex = 0;
  const _splashScreenPanelContents = [];
  let _splashScreenArrowLeft = null;
  let _splashScreenArrowRight = null;
  let _splashScreenAutoSwapPanelTimeline = null;
  let _splashScreenMask = null;
  let _timeScale = 1;
  let _tutorialClosed = false;
  const _buttonIdleTimerData = {};

  let _autoClickForReplayRewatchTimer = undefined;

  ///////////////////////

  const devMode = false;
  Reflex.developerModeData.checkUnusuedResources = devMode;
  Reflex.developerModeData.highlightTranslatedText = devMode;
  Reflex.developerModeData.showButtonHitAreas = devMode;
  Reflex.developerModeData.fastSpin = devMode;

  ///////////////////////

  gameData.gameName = _gameName;
  gameData.gameNameShort = _gameNameShort;
  gameData.gameVersionMajor = _gameVersionMajor;
  gameData.gameVersionMinor = _gameVersionMinor;
  gameData.gameVersionBugFix = _gameVersionBugFix;
  gameData.gameReleaseDate = _gameReleaseDate;
  gameData.version = '' + _gameVersionMajor + '.' + _gameVersionMinor + '.' + _gameVersionBugFix;

  function enableSpeedUp() {
    const caller = new Error().stack?.split('\n')[2]?.trim().split(' ')[1];
    if (caller === 'GDK.readyCb') {
      document.addEventListener('keydown', (event) => {
        let validOptionPressed = true;
        if (event.key === '+') {
          _timeScale += 0.1;
        } else if (event.key === '-') {
          _timeScale -= 0.1;
        } else if (event.key === '*') {
          _timeScale *= 2;
        } else if (event.key === '/') {
          _timeScale /= 2;
        } else if (event.key === '0') {
          _timeScale = 0;
        } else if (event.key === '1') {
          _timeScale = 1;
        } else if (event.key === '2') {
          _timeScale = 2;
        } else if (event.key === '3') {
          _timeScale = 3;
        } else if (event.key === '4') {
          _timeScale = 4;
        } else if (event.key === '5') {
          _timeScale = 5;
        } else if (event.key === '6') {
          _timeScale = 6;
        } else if (event.key === '7') {
          _timeScale = 7;
        } else if (event.key === '8') {
          _timeScale = 8;
        } else if (event.key === '9') {
          _timeScale = 9;
        } else {
          validOptionPressed = false;
        }

        if (validOptionPressed) {
          if (_timeScale > 256) _timeScale = 256;
          if (_timeScale < 0) _timeScale = 0;

          setSpeed(_timeScale);
        }
      });
    }
  }

  function createVersion() {
    var versionString = _gameName + ' v' + _gameVersionMajor + '.' + _gameVersionMinor + '.' + _gameVersionBugFix;
    Debug.log(versionString);
    // console.log(versionString);
  }

  function initialise(gameConfigTask) {
    gameData.gameConfig = gameConfigTask.data;

    gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

    createVersion();

    gameData.expandIndices = {
      top: 0,
      bottom: 8,
    };
    gameData.contractIndices = {
      top: 5,
      bottom: 8,
    };

    // let stakeController = resourceManager.getController('stakeController');
    // if (gameData.recoveryStake) {
    //   gameData.baseGameRecStakeIdx = gameData.currentStakeIndex;
    //   game.changeStake(gameData.recoveryStake);
    // } else {
    //   game.changeStake(stakeController.Stakes[gameData.currentStakeIndex]);
    // }

    messageBus.subscribe('game:backFromReplay', backFromReplay);
  }

  function onModal() {}

  function dimAllSymbols(dim, tint) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, tint);
    }
  }

  function onCloseTutorial() {
    stopAutoClickForReplayRewatch();

    if (_tutorialClosed) {
      // just incase press and timer - shouldnt happen but
      return;
    }

    _tutorialClosed = true;

    if (gameData.recoveryStake) {
      gameData.baseGameRecStakeIdx = gameData.currentStakeIndex;
      game.changeStake(gameData.recoveryStake);
    }

    disableSplashScreen();

    const containers = [
      { id: 'splashContainer', visible: false },
      { id: 'loadingContainer', visible: false },
      { id: 'jackCharacterAnimContainer', visible: true },
      { id: 'backgroundContainer', visible: true },
    ];
    for (let i = 0; i < containers.length; i++) {
      resourceManager.getContainer(containers[i].id).visible = containers[i].visible;
    }
    const resources = [
      { id: 'jacksSpineAnimContainer', visible: false },
      { id: 'maxWinPopup', visible: false },
      { id: 'maxGambleWinReachedPopup', visible: false },
      { id: 'landscapeBackgroundOrientationContainer:landscapeFSBackgroundContainer', visible: false },
      { id: 'portraitBackgroundOrientationContainer:portraitFSBackgroundContainer', visible: false },
      { id: 'landscapeBackgroundOrientationContainer:landscapeCastleContainer:landscapeFSCastle', visible: false },
      { id: 'portraitBackgroundOrientationContainer:portraitCastleContainer:portraitFSCastle', visible: false },
      {
        id: 'landscapeBackgroundOrientationContainer:landscapeBasegameBackgroundContainer:landscapeBasegameBackgroundTop',
        visible: false,
      },
      {
        id: 'portraitBackgroundOrientationContainer:portraitBasegameBackgroundContainer:portraitBasegameBackgroundTop',
        visible: false,
      },
    ];
    for (let i = 0; i < resources.length; i++) {
      resourceManager.get(resources[i].id).visible = resources[i].visible;
    }

    gameData.winningsText = resourceManager.get('winningsText');

    // AllWaysPayWinAnimator.initialise();
    PayAnywhereWinAnimator.initialise();

    game.loadingBackgroundLandscape = resourceManager.get('splashBackgroundContainer:splashBackgroundL');
    game.loadingBackgroundLandscape.clearInteractiveCallbacks();

    game.loadingBackgroundPortrait = resourceManager.get('splashBackgroundContainer:splashBackgroundP');
    game.loadingBackgroundPortrait.clearInteractiveCallbacks();

    if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
      gdk.requestFullscreen();
    }

    if (gdk.deviceInfo.chrome && gdk.deviceInfo.android) {
      var chromeVersion = Number(
        String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf('.'))
      );
      if (chromeVersion >= 55) {
        // Chrome will only start audio on a touch
        Howler.ctx.resume();
      }
    }

    // Set up character either behind or in front of message bar
    gameData.gameContainer = resourceManager.getContainer('gameContainer');
    gameData.helpPageScroll = resourceManager.get('helpPageScrollContainer:helpPageScroll');
    resourceManager.getContainer('loadingContainer').visible = false;
    resourceManager.getContainer('gameContainer').visible = true;
    resourceManager.getContainer('msgBoxPopupContainer').visible = true;
    resourceManager.getContainer('gameButtonContainer').visible = true;
    resourceManager.getContainer('particleContainer').visible = true;
    resourceManager.getContainer('buyABonusContainer').visible = true;
    resourceManager.getContainer('settingsMenuContainer').visible = true;

    const bgContainer = resourceManager.getContainer('backgroundContainer');
    bgContainer.visible = true;

    gameData.gameMask = new PIXI.Graphics();
    gameData.gameMask.beginFill(0xffffff);
    gameData.gameMask.drawRect(0, 0, 1, 1);
    bgContainer.addChild(gameData.gameMask);

    systemData.gameContainer.mask = gameData.gameMask;

    if (gameData.gameMask) {
      if (systemData.isLandscape) {
        gameData.gameMask.scale.x = 1280;
        gameData.gameMask.scale.y = 720;
      } else {
        gameData.gameMask.scale.x = 720;
        gameData.gameMask.scale.y = 1280;
      }
    }

    if (gameData.license === '' || gameData.license === undefined) {
      gameData.license = 'default';
    }

    let license = gameData.license.toUpperCase();

    if (license === 'BR') {
      resourceManager.get('helpPageScrollContainer:helpPageScroll').open();
    }

    startReelsBurstTweens();

    gameData.inputOverlord.setState('enabled');

    gameController.initialise();
    console.log('switchState to WAIT_FOR_START');
    gameController.stateMachine.switchState('WAIT_FOR_START');

    startIdleTimerForButtons();
  }

  async function startIdleTimerForButtons() {
    await timerManager.delayAsync(5000);

    // i know we have golden bet idle
    // and bonus buy idle
    // but i think if we fire an event, thats all we need to do
    messageBus.post('buttonIdleTimerExpired', null);

    // then call ourselves again
    // i dont think it should cause an issue
    timerManager.addTimeout(16, () => {
      startIdleTimerForButtons();
    });
  }

  function startReelsBurstTweens() {
    const burst1 = resourceManager.get('slotContainer:reelsBacker:BurstContainer:Burst1');
    const burst2 = resourceManager.get('slotContainer:reelsBacker:BurstContainer:Burst2');

    burst1.rotation = 0;
    burst2.rotation = 0;
    const rotateBurst1Tween = gsap.to(burst1, {
      duration: 36,
      rotation: 359 * (Math.PI / 180),
      repeat: -1,
      ease: 'none',
    });
    const rotateBurst2Tween = gsap.to(burst2, {
      duration: 36,
      rotation: -359 * (Math.PI / 180),
      repeat: -1,
      ease: 'none',
    });
  }

  function enableEncore(enabled) {
    gameData.encoreEnabled = enabled;
  }

  function blurGame(enable, value) {
    if (resourceManager.selectedAssetResolution.name === 'standard') {
      value = checkForDefined(value) ? value : 1;
      resourceManager.getContainer('gameContainer').filters = enable ? [new PIXI.filters.BlurFilter(value)] : [];
      resourceManager.getContainer('gameButtonContainer').filters = enable ? [new PIXI.filters.BlurFilter(value)] : [];
    }
  }

  function changeStake(selectedStake, bpl) {
    gameData.stakeMeter.set(selectedStake);
    gdk.playerChangedStake(selectedStake);
  }

  function resetWinnings() {
    gameData.winningsMeter.set(0);
  }

  function creditChanged(creditTask) {
    // console.log('game:creditChanged', creditTask);
    gameData.credit = creditTask.data.balance;
    gameData.creditMeter.set(creditTask.data.balance);
  }

  function onLoaded(loader, res) {
    setupPerformanceDependentObjects();
  }

  function goToSplash() {
    if (!gdk.getPlatformAllowsSplashScreen()) {
      if (gameData.license === '' || gameData.license === undefined) {
        gameData.license = 'default';
      }

      let license = gameData.license.toUpperCase();

      if (license !== 'BR') {
        gdk.loadingClosed();
      }
      Reflex.updateViewport();
    } else {
      // splash screen is required
      //
      // but this one is a bit different
      initSplashScreen();
    }
  }

  function initSplashScreen() {
    grabSplashScreenComponents();
    setupMaskForSplashScreen();
    initSplashScreenArrowButtons();
    showCurrentSplashScreenPanel();

    _splashScreenAutoSwapPanelTimeline = gsap.timeline({ repeat: -1 }).call(
      () => {
        swapSplashScreenPanel(1);
      },
      undefined,
      '<+=5'
    );

    gameData.inputOverlord.setState('disabled');
  }

  function setupMaskForSplashScreen() {
    _splashScreenMask = new PIXI.Graphics();
    _splashScreenMask.beginFill(0xffffff);
    _splashScreenMask.drawRect(0, 0, 1, 1);

    const splashContainer = resourceManager.getContainer('splashContainer');
    splashContainer.addChild(_splashScreenMask);
    splashContainer.mask = _splashScreenMask;

    if (_splashScreenMask) {
      if (systemData.isLandscape) {
        _splashScreenMask.scale.x = 1280;
        _splashScreenMask.scale.y = 720;
      } else {
        _splashScreenMask.scale.x = 720;
        _splashScreenMask.scale.y = 1280;
      }
    }
  }

  function grabSplashScreenComponents() {
    _splashScreenArrowLeft = resourceManager.get('splashButtonsContainer:arrowLeft');
    _splashScreenArrowRight = resourceManager.get('splashButtonsContainer:arrowRight');

    for (let i = 0; i < 3; i++) {
      _splashScreenPanelContents[i] = resourceManager.get(
        `splashPanelContainer:splashPanelContents:splashPanelContent${i}`
      );
    }

    const leftPolygon = [50, -140, 10, -140, -48, 0, 10, 140, 50, 140];
    _splashScreenArrowLeft.hitArea = new PIXI.Polygon(leftPolygon);
    const rightPolygon = [-50, -140, -10, -140, 48, 0, -10, 140, -50, 140];
    _splashScreenArrowRight.hitArea = new PIXI.Polygon(rightPolygon);

    if (Reflex.developerModeData.showButtonHitAreas) {
      _splashScreenArrowLeft.graphics = new PIXI.Graphics();
      _splashScreenArrowLeft.graphics.beginFill(0x0000ff);
      _splashScreenArrowLeft.graphics.lineStyle(4, 0x0000ff, 1);
      _splashScreenArrowLeft.graphics.drawPolygon(leftPolygon);
      _splashScreenArrowLeft.graphics.endFill();
      _splashScreenArrowLeft.graphics.alpha = 0.5;
      _splashScreenArrowLeft.addChild(_splashScreenArrowLeft.graphics);
    }

    if (Reflex.developerModeData.showButtonHitAreas) {
      _splashScreenArrowRight.graphics = new PIXI.Graphics();
      _splashScreenArrowRight.graphics.beginFill(0x0000ff);
      _splashScreenArrowRight.graphics.lineStyle(4, 0x0000ff, 1);
      _splashScreenArrowRight.graphics.drawPolygon(rightPolygon);
      _splashScreenArrowRight.graphics.endFill();
      _splashScreenArrowRight.graphics.alpha = 0.5;
      _splashScreenArrowRight.addChild(_splashScreenArrowRight.graphics);
    }
  }

  async function tweenFromToAsync(targets, fromVars, toVars, tweenInfo = null) {
    let resolver = null;
    const tweenPromise = new Promise((resolve) => {
      resolver = resolve;
    });

    const origOnComplete = toVars.onComplete;
    toVars.paused = true;
    toVars.onComplete = () => {
      if (origOnComplete) {
        origOnComplete();
      }
      resolver();
    };

    const tween = gsap.fromTo(targets, fromVars, toVars);
    tween.time(0).restart(true);

    if (tweenInfo) {
      tweenInfo.tween = tween;
      tweenInfo.resolver = resolver;
      tweenInfo.promise = tweenPromise;
    }

    return tweenPromise;
  }

  async function swapSplashScreenPanel(direction) {
    if (_splashScreenPanelSwapping) return;

    // we dont disable these, otherwise you could click on the background
    // _splashScreenArrowLeft.interactive = false;
    // _splashScreenArrowRight.interactive = false;
    _splashScreenPanelSwapping = true;

    if (direction === -1) {
      _splashScreenArrowLeft.alpha = 0.7;
    } else {
      _splashScreenArrowRight.alpha = 0.7;
    }

    // fade out current panel
    // and fade in new one

    const currentIndex = _currentSplashScreenPanelIndex;
    let nextIndex = _currentSplashScreenPanelIndex + direction;
    if (nextIndex < 0) {
      nextIndex = _splashScreenPanelContents.length - 1;
    } else if (nextIndex > _splashScreenPanelContents.length - 1) {
      nextIndex = 0;
    }

    _splashScreenPanelContents[nextIndex].visible = true;
    _splashScreenPanelContents[nextIndex].alpha = 0;

    await Promise.all([
      tweenFromToAsync(
        _splashScreenPanelContents[currentIndex],
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.25,
        }
      ),
      tweenFromToAsync(
        _splashScreenPanelContents[nextIndex],
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.25,
        }
      ),
    ]);

    _splashScreenPanelContents[currentIndex].visible = false;
    _splashScreenPanelContents[currentIndex].alpha = 0;

    _splashScreenArrowLeft.alpha = 1;
    _splashScreenArrowRight.alpha = 1;

    _currentSplashScreenPanelIndex = nextIndex;
    // _splashScreenArrowLeft.interactive = true;
    // _splashScreenArrowRight.interactive = true;
    _splashScreenPanelSwapping = false;
  }

  function showCurrentSplashScreenPanel() {
    for (let i = 0; i < _splashScreenPanelContents.length; i++) {
      _splashScreenPanelContents[i].visible = false;
      _splashScreenPanelContents[i].alpha = 0;
    }

    _splashScreenPanelContents[_currentSplashScreenPanelIndex].visible = true;
    _splashScreenPanelContents[_currentSplashScreenPanelIndex].alpha = 1;
  }

  function disableSplashScreen() {
    if (_splashScreenAutoSwapPanelTimeline) {
      _splashScreenAutoSwapPanelTimeline.pause();
    }
    disableSplashScreenArrowButtons();
    const splashContainer = resourceManager.getContainer('splashContainer');
    splashContainer.removeChild(_splashScreenMask);
    splashContainer.mask = null;
    _splashScreenMask = null;
  }

  function disableSplashScreenArrowButtons() {
    const arrowLeft = resourceManager.get('splashButtonsContainer:arrowLeft');
    const arrowRight = resourceManager.get('splashButtonsContainer:arrowRight');

    arrowLeft.interactive = false;
    arrowRight.interactive = false;
  }

  function initSplashScreenArrowButtons() {
    _splashScreenArrowLeft.interactive = true;
    _splashScreenArrowRight.interactive = true;

    _splashScreenArrowLeft.on('mouseup', function () {
      swapSplashScreenPanel(-1);
      _splashScreenAutoSwapPanelTimeline.pause();
      return;
    });
    _splashScreenArrowLeft.on('touchend', function () {
      swapSplashScreenPanel(-1);
      _splashScreenAutoSwapPanelTimeline.pause();
      return;
    });
    _splashScreenArrowLeft.on('mouseover', function () {
      return;
    });

    _splashScreenArrowRight.on('mouseup', function () {
      swapSplashScreenPanel(1);
      _splashScreenAutoSwapPanelTimeline.pause();
      return;
    });
    _splashScreenArrowRight.on('touchend', function () {
      swapSplashScreenPanel(1);
      _splashScreenAutoSwapPanelTimeline.pause();
      return;
    });
    _splashScreenArrowRight.on('mouseover', function () {
      return;
    });
  }

  function onResize() {
    if (gameData.gameMask) {
      if (systemData.isLandscape) {
        gameData.gameMask.scale.x = 1280;
        gameData.gameMask.scale.y = 720;
      } else {
        gameData.gameMask.scale.x = 720;
        gameData.gameMask.scale.y = 1280;
      }
    }

    if (_splashScreenMask) {
      if (systemData.isLandscape) {
        _splashScreenMask.scale.x = 1280;
        _splashScreenMask.scale.y = 720;
      } else {
        _splashScreenMask.scale.x = 720;
        _splashScreenMask.scale.y = 1280;
      }
    }
  }

  function onReady() {
    var numSymbols = Object.keys(resourceManager.getConfiguration().symbols).length;

    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    for (var i = 0; i < numSymbols; ++i) {
      slotMachine.symbolCreationCallbacks[i.toString()] = helper.getSymbolChildrenDescriptions;
    }

    // this tries to look for a child sprite in a very specific location
    // with an id containing "glow". then it applies BLEND_MODE.ADD
    // adding a bitmap font to the symbol make it break as the detection is very specific
    // the function should really be updated to be a bit betterer
    // for (var i = 0; i < 5; i++) {
    //   slotMachine.reels[i].setAnySymbolCreatedCallback(helper.symbolCreationCallback);
    // }

    Reflex.deregisterEventHandler('ready', onReady);
  }

  function backFromReplay(data) {
    if (
      soundManager.sharedMode === true // we have been sharing the soundManager
    ) {
      // im going to assume the back button has been pressed during watching a replay
      // the ygg platform is telling us to unmute audio
      // stop any sounds currently playing from the old replay game
      // then clear the sharedMode flag
      // we need to restore what audio and what levels they were playing at
      // this think this will be down to each client to handle this as ids are stored all over the place
      // the music managers are inconsistant
      soundManager.stopAllSounds();
      soundManager.sharedMode = false;
      messageBus.post('sounds:restorePreviouslyPlayingAudio', {
        reason: 'back from replay',
      });
    }
  }

  function setSpeed(speed) {
    // not sure this is needed here!
    // if (Reflex.gamePaused || Reflex.platformPaused) {
    //   soundManager.pauseAllSounds();
    // } else {
    //   soundManager.resumeAllSounds();
    // }
    soundManager.setTimeScale(speed);
    gsap.globalTimeline.timeScale(speed);
    Reflex.setGameSpeed(speed);
  }

  async function playMovie(movie) {
    movie.visible = true;
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });
    movie.gotoAndPlay(0);
    movie.onComplete = () => {
      resolver();
    };
    await promise;
    movie.visible = false;
  }

  // we should be able to loop non looping movies now
  // and they will keep looping until we set stopLooping on the movie
  // if we need to stop earlier, then i think we can without worrying about the promise?
  async function loopMovie(movie, startingframe = 0) {
    movie.visible = true;
    console.log('clear movie.stopLooping');
    movie.stopLooping = false;
    let again = false;
    let frame = startingframe;
    do {
      again = false;
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });
      movie.gotoAndPlay(frame);
      frame = 0;
      movie.onComplete = () => {
        resolver();
      };
      await promise;

      if (movie.stopLooping !== true) {
        again = true;
      }
    } while (again === true);
    movie.visible = false;
  }

  async function tweenFromToAsync(targets, fromVars, toVars, tweenInfo = null) {
    let resolver = null;
    const tweenPromise = new Promise((resolve) => {
      resolver = resolve;
    });

    const origOnComplete = toVars.onComplete;
    toVars.paused = true;
    toVars.onComplete = () => {
      if (origOnComplete) {
        origOnComplete();
      }
      resolver();
    };

    const tween = gsap.fromTo(targets, fromVars, toVars);
    tween.time(0).restart(true);

    if (tweenInfo) {
      tweenInfo.tween = tween;
      tweenInfo.resolver = resolver;
      tweenInfo.promise = tweenPromise;
    }

    return tweenPromise;
  }

  function randomNumberBetween(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  function autoClickForReplayRewatch(cb, time = 4000) {
    if (gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) {
      stopAutoClickForReplayRewatch(); // just in case
      _autoClickForReplayRewatchTimer = timerManager.addTimeout(time, cb);
    }
  }

  function stopAutoClickForReplayRewatch() {
    if (_autoClickForReplayRewatchTimer) {
      timerManager.stop(_autoClickForReplayRewatchTimer);
      _autoClickForReplayRewatchTimer = undefined;
    }
  }

  var game = {};

  Object.defineProperties(game, {
    enableSpeedUp: {
      value: enableSpeedUp,
    },
    enableEncore: {
      value: enableEncore,
    },
    onCloseTutorial: {
      value: onCloseTutorial,
    },
    initialise: {
      value: initialise,
    },
    blurGame: {
      value: blurGame,
    },
    changeStake: {
      value: changeStake,
    },
    resetWinnings: {
      value: resetWinnings,
    },
    dimAllSymbols: {
      value: dimAllSymbols,
    },

    goToSplash: {
      value: goToSplash,
    },

    tweenFromToAsync: {
      value: tweenFromToAsync,
    },
    randomNumberBetween: {
      value: randomNumberBetween,
    },
    playMovie: {
      value: playMovie,
    },
    loopMovie: {
      value: loopMovie,
    },

    autoClickForReplayRewatch: {
      value: autoClickForReplayRewatch,
    },
    stopAutoClickForReplayRewatch: {
      value: stopAutoClickForReplayRewatch,
    },
  });

  ///////////////////
  // subscriptions //
  ///////////////////

  tabbedDemoManager.COLUMNS = 6;
  messageBus.subscribe('common:BalanceEvent', creditChanged);
  messageBus.subscribe('stake:stakeChanged', changeStake);
  messageBus.subscribe('game:modal', onModal);
  Reflex.registerEventHandler('ready', onReady);
  Reflex.registerEventHandler('resize', onResize);

  resourceManager.onLoadCompleteBase = resourceManager.onLoadComplete;
  resourceManager.onLoadComplete = function () {
    Loader.progressBar.scale.x = 1;
    resourceManager.isLoaded = true; // so timer is running
    timerManager.addTimeout(1000, () => {
      resourceManager.onLoadCompleteBase(1);
    });
  };

  // resourceManager.onLoadComplete = function (delayInMS) {
  //   const duration = typeof delayInMS === 'number' && delayInMS > 0 ? delayInMS : 1000;
  //   if (Loader?.progressBar?.scale) {
  //     Loader.progressBar.scale.x = 1;
  //   }
  //   resourceManager.isLoaded = true; // so timer is running
  //   timerManager.addTimeout(duration, () => {
  //     for (let i = 0; i < resourceManager.loadCompleteCallbacks.length; i++) {
  //       resourceManager.loadCompleteCallbacks[i]('Creating Resources');
  //     }
  //     // Art and sounds have now been loaded, and we have pre created movies
  //     resourceManager.onEverythingLoaded();
  //   });
  // };

  timerManager.delayAsync = async function (time, tickCallback, completeCallback, data) {
    if (!tickCallback) {
      tickCallback = (progress) => {};
    }
    if (!completeCallback) {
      completeCallback = () => {};
    }
    // cant expire it early at the moment!!!!!
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    const completeCB = () => {
      completeCallback();
      resolver();
    };

    const timer = timerManager.addDelayedTimer(0, time, tickCallback, completeCB, data);

    await promise;
  };

  return game;
})();
